// The timed views — one day, or seven. They are the same picture at two widths, so they
// are one component: an hour axis down the side and N day columns beside it.
//
// Splitting them into DayGrid.js and WeekGrid.js would have meant two copies of the axis,
// the hour lines and the "is this today" marking, which is exactly what the DRY rule
// exists to stop. The day view is the week view with one column.
import he from '../../i18n/he';
import { todayStr } from '../../utils/dates';
import { HOUR_MARKS, WORK_START, DAY_MINUTES, asTime } from './workingDay';
import { weekdayOf } from './calendarDates';
import DayColumn from './DayColumn';

const linePosition = (minutes) => `${((minutes - WORK_START) / DAY_MINUTES) * 100}%`;

export default function TimeGrid({ days, byDay, partners, onOpen, onPickEmpty }) {
  const today = todayStr();

  return (
    <div className={`time-grid${days.length === 1 ? ' single' : ''}`}>
      <div className="time-grid-head">
        <div className="time-axis-head" />
        {days.map((d) => (
          <div key={d} className={`day-head${d === today ? ' today' : ''}`}>
            <span className="day-name">{he.calendar.weekdays[weekdayOf(d)]}</span>
            <span className="day-number">{Number(d.slice(8, 10))}</span>
          </div>
        ))}
      </div>

      <div className="time-grid-body">
        <div className="time-axis">
          {HOUR_MARKS.map((m) => (
            <span key={m} className="hour-mark" style={{ top: linePosition(m) }}>
              {asTime(m)}
            </span>
          ))}
        </div>

        <div className="day-columns">
          {/* One set of hour lines behind every column, so they cannot drift apart. */}
          <div className="hour-lines">
            {HOUR_MARKS.map((m) => (
              <div key={m} className="hour-line" style={{ top: linePosition(m) }} />
            ))}
          </div>
          {days.map((d) => (
            <DayColumn
              key={d}
              date={d}
              meetings={byDay.get(d) || []}
              partners={partners}
              onOpen={onOpen}
              onPickEmpty={onPickEmpty}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
